import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × VAN CLEEF & ARPELS: Combinatorial elegance
// Clover symmetry, modular repetition, star geometry
export function VasarelyVancleefMode({ brand }: ModeRendererProps) {
  const vcBlue = "#1E3A8A";
  const vcGold = "#D4AF37";

  return (
    <g>
      {/* Elegant deep blue background */}
      <defs>
        <linearGradient id="vancleef-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0F1D44" />
          <stop offset="100%" stopColor={vcBlue} />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#vancleef-bg)" />

      <g transform="translate(397 540)">
        {/* Alhambra clover pattern (four-leaf modular) */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 10 }).map((_, j) => {
            const x = (i - 3.5) * 80;
            const y = (j - 4.5) * 80;
            
            return (
              <g key={`${i}-${j}`}>
                {/* Four-leaf clover */}
                {[0, 90, 180, 270].map((angle) => {
                  const rad = (angle * Math.PI) / 180;
                  const leafX = x + Math.cos(rad) * 16;
                  const leafY = y + Math.sin(rad) * 16;
                  
                  return (
                    <circle
                      key={angle}
                      cx={leafX}
                      cy={leafY}
                      r="14"
                      fill={vcGold}
                      opacity="0.3"
                    />
                  );
                })}
                {/* Center gem */}
                <circle cx={x} cy={y} r="5" fill={vcGold} opacity="0.6" />
              </g>
            );
          })
        )}

        {/* Modular constellation connections */}
        {Array.from({ length: 20 }).map((_, i) => {
          const angle1 = (i * Math.PI) / 10;
          const angle2 = ((i + 3) * Math.PI) / 10;
          const r = 180;
          
          return (
            <line
              key={i}
              x1={Math.cos(angle1) * r}
              y1={Math.sin(angle1) * r}
              x2={Math.cos(angle2) * r}
              y2={Math.sin(angle2) * r}
              stroke={vcGold}
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Star geometry (étoile motif) */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 220;
          
          return (
            <g key={angle}>
              {/* Eight-pointed star */}
              {[0, 45, 90, 135, 180, 225, 270, 315].map((star) => {
                const sRad = ((angle + star) * Math.PI) / 180;
                const dist = star % 90 === 0 ? 20 : 12;
                
                return (
                  <line
                    key={star}
                    x1={Math.cos(rad) * r}
                    y1={Math.sin(rad) * r}
                    x2={Math.cos(rad) * r + Math.cos(sRad) * dist}
                    y2={Math.sin(rad) * r + Math.sin(sRad) * dist}
                    stroke={vcGold}
                    strokeWidth="2"
                    opacity="0.5"
                  />
                );
              })}
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="6"
                fill={vcGold}
                opacity="0.7"
              />
            </g>
          );
        })}

        {/* Harmonic circles */}
        {Array.from({ length: 18 }).map((_, i) => {
          const r = 30 + i * 15;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={vcGold}
              strokeWidth="1"
              opacity={0.25 - i * 0.01}
            />
          );
        })}

        {/* Central medallion */}
        <circle cx="0" cy="0" r="40" fill={vcGold} opacity="0.25" />
        <circle cx="0" cy="0" r="40" fill="none" stroke={vcGold} strokeWidth="2" opacity="0.6" />
        
        {/* Four-leaf center */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * 25}
              cy={Math.sin(rad) * 25}
              r="10"
              fill={brand.aqua}
              opacity="0.4"
            />
          );
        })}
      </g>

      {/* Van Cleef inscription */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="serif" fontSize="10" fill={vcGold} opacity="0.7" fontStyle="italic">
        élégance combinatoire
      </text>
    </g>
  );
}
